<template>
	<nk-page commercialAccess="System">
		<div class="h-100 d-flex flex-column overflow-auto">
			<div class="form-container h-100">
				<div class="container-fluid h-100">
					<div class="row flex-row-reverse h-100">
						<div class="col-12 flex-1">
							<div class="justify-content-between pr-1 pl-2 " style="display: flex">
								<label>{{ $t('note.title') + ':' }}</label>
								<div class="" style="display: flex">
									<label>{{ $t('note.last-update') }} : &nbsp;</label>
									<nk-label v-model="modifyData"></nk-label>
								</div>
							</div>
							<nk-col-form-group :labelSizes="{ sm: 12 }" :dataSizes="{ sm: 12 }" :labelAligns="{ sm: 'right', md: 'right', lg: 'right' }">
								<nk-textarea :rows="10" v-model="note"></nk-textarea>
							</nk-col-form-group>
						</div>

					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>
<script>
	import _ from 'lodash'
	import { post } from '~/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import AccessControl from '~/views/operation-roles/access-control'
	import validators, { isEmpty } from "@/statics/validators"
	import $sc from "@/plugins/shortcut.collection"

	export default {
		modal: {
			size: 'MD',
			stateUID: 'note123-manager',
		},
		components: {
		},
		props: {
			data: { type: Object },
			options: { type: Object },
		},
		data() {
			return {
				validators: {
					text: validators('required'),
				},
				note: null,
				modifyData: '---',
				saveProductButton: {
					title: this.$t('save'),
					shortcut: $sc.find('save'),
					isPrimary: false,
					handle: () => {
						this.saveNote()
					},
					icon: 'save',
					// policyClaims: { or: ['Product_Product_Edit', 'Product_Product_Add'] },
				},
				settings: {
					entityType: '',
					entityId: '',
				}

			}
		},
		computed: {},
		mounted() {
			this.settings = _.extend({}, this.settings, this.options)

			this.getNote()

			this.prepareWindow(`${this.$t('note.title-prefix')} ${this.options.entityTitle.toLocaleDigits()}`, [
				this.saveProductButton,
			])

		},
		created() { },
		methods: {
			async getNote() {
				var url = Endpoints.getUrl('note.get')
				let data = {
					"entityId": this.settings.entityId,
					"entityType": this.settings.entityType,
				}
				let wait = this.$wait(this.grandParent)
				await post(url, data, null, { silent: true })
					.then((response) => {
						wait.end()
						this.note = response.data.text
						this.modifyData = new Date(response.data.created).toLocaleTimeString('fa-IR').toString().toLocaleDigits() + '  ' + new Date(response.data.created).toLocaleDateString('fa-IR').toString().toLocaleDigits()
					})
					.catch(() => {
						wait.end()
					})
			},
			async saveNote() {


				let url = Endpoints.getUrl('note.modify')


				let data = {
					"entityId": this.settings.entityId,
					"entityType": this.settings.entityType,
					"text": this.note
				}

				// if (this.validateInputs()) {
				let wait = this.$wait(this.grandParent)
				await post(url, data)
					.then((response) => {
						wait.end()
						this.$toast(this.$t('note.modify-successful'), { type: 'success' })
						this.resolve(response)
					})
					.catch(() => {
						wait.end()
						// this.$toast(this.$t('note.modify-fail'))
					})
			},

		},
	}
</script>
<style>
	.attachment-title {
		text-align: center;
		font-size: 1.2rem;
		margin: auto;
		background-color: #fffef6;
		margin: -5px 0 30px 0;
		border-bottom: 1px dashed #ffc400;
		color: #a27c00;
		padding: 10px;
	}
</style>
